import { makeStyles } from '@mui/styles'
import {
  CHARCOAL,
  GAINSBORO_BORDER,
  GAINSBORO_LIGHT,
  GRAYISH_BLUE,
  GUNMETAL,
  MEDIUM_GRAY,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  RAVEN,
  VIVID_BLUE,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

const useStyles = makeStyles(() => ({
  statusSelect: {
    width: '100%',
    padding: 10,

    '& > div': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  select: {
    width: '100%',

    '& > div': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  detailsTypeWithHeadTooltip: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  headTooltip: {
    fontFamily: URBANIST,
    fontSize: 12,
    cursor: 'pointer',
  },
  helpIcon: {
    width: 14,
    height: 14,
  },
  optionPrimary: {
    fontFamily: URBANIST,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '160%',
    color: MIDNIGHT_EXPRESS,
    cursor: 'pointer',
  },
  detailsRow: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      marginTop: 3,
    },
  },
  trackingIdDetailsRow: {
    flexDirection: 'column',
  },
  inputHead: {
    flexShrink: 0,
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0.2,
    width: '30%',
    marginRight: 10,
    color: CHARCOAL,
  },
  inputText: {
    fontFamily: URBANIST,
    fontSize: 14,
    lineHeight: '150%',
  },
  input: {
    '& > div': {
      borderColor: 'transparent',
      '& > input': {
        fontFamily: URBANIST,
        color: MIDNIGHT_EXPRESS,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '160%',
      },
    },
  },
  datePicker: {
    '& > div': {
      border: '2px solid transparent',
    },
  },
  copyIcon: {
    color: GRAYISH_BLUE,
  },
  table: {
    borderCollapse: 'collapse',
  },
  tableHead: {
    width: '100%',
    height: 'auto',
    border: 'none',
  },
  headerRow: {
    backgroundColor: 'RGBA(189, 189, 189, 0.2)',
    borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,

    '&:hover': {
      backgroundColor: 'RGBA(189, 189, 189, 0.2)',
      borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,
    },
  },
  headerCell: {
    color: 'RGBA(2, 2, 2, 0.2)',
    padding: 5,
    fontFamily: URBANIST,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '130%',
  },
  tableRow: {
    border: 'none',
    cursor: 'auto',
  },
  bodyCell: {
    padding: 5,
    borderBottom: `1px solid ${GAINSBORO_BORDER}`,
    color: GUNMETAL,
    fontFamily: URBANIST,
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '130%',
  },
  upperCaseText: {
    textTransform: 'uppercase',
  },
  noWrapText: {
    whiteSpace: 'nowrap',
  },
  inputRoot: {
    width: '100%',
  },
  selectWrapper: {
    width: '100%',
    position: 'relative',
    borderRadius: 4,
  },
  packageIdCell: {
    maxWidth: 120,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: VIVID_BLUE,
  },
  openLinkCell: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  errorBlock: {
    margin: 20,
  },
  wrongPickedUpItemCheckbox: {
    padding: 0,
  },
  buttonsContainer: {
    position: 'fixed',
    width: '30%',
    bottom: 0,
    background: WHITE,
    borderTop: `1px solid ${GAINSBORO_BORDER}`,
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 -10px',
    padding: 10,
    zIndex: 10,
  },
  button: {
    padding: '0 10px',
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    lineHeight: '140%',
    fontWeight: 700,
    height: 40,
    border: 'none',
    borderRadius: 4,

    '&:hover': {
      opacity: 0.8,
    },
  },
  cancelButton: {
    backgroundColor: MEDIUM_GRAY,
    color: WHITE,

    '&:hover': {
      backgroundColor: MEDIUM_GRAY,
      border: 'none',
    },
  },
  saveButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    color: WHITE,

    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
      border: 'none',
    },
  },
  disableIcon: {
    display: 'none',
  },
  trackingInput: {
    position: 'relative',
    width: '100%',
  },
  noLabelButton: {
    fontSize: 13,
    color: NEON_BLUE_LIGHT,
    fontFamily: URBANIST,
    cursor: 'pointer',
  },
  dndStyles: {
    padding: 9,
    background: GAINSBORO_LIGHT,
    border: `1px dashed rgba(0, 0, 0, 0.3)`,
  },
  dropZoneLabel: {
    fontFamily: URBANIST,
    fontSize: 11,
    color: '#000000',
    '& > span': {
      color: NEON_BLUE_LIGHT,
    },
  },
  packingSlipGroup: {
    marginTop: 10,
  },
  PDFLink: {
    cursor: 'pointer',
    fontFamily: URBANIST,
    fontWeight: 500,
    fontSize: 13,
    lineHeight: '15px',
    color: NEON_BLUE_LIGHT,
    marginTop: 6,
  },
  PDFLinkDisabled: {
    color: RAVEN,
    pointerEvents: 'none',
    marginTop: 6,
  },
  PDFLinkRow: {
    display: 'flex',
    alignItems: 'center',
  },
  delim: {
    fontFamily: URBANIST,
    fontSize: 13,
    lineHeight: '150%',
    color: RAVEN,
    margin: '6px 5px 0',
  },
  counterWrap: {
    maxHeight: 30,
    maxWidth: 140,
    margin: '6px 0',
  },
  counterButton: {
    borderRadius: 0,
    maxHeight: 'inherit',
    padding: '5px 20px',
  },
  counterInputRoot: {
    textAlign: 'center',
    fontFamily: URBANIST,
    fontSize: 16,
    border: `1px solid ${GAINSBORO_BORDER}`,
  },
  counterInput: {
    '& > div': {
      borderRadius: 0,
    },
  },
  inputHeadWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 10,
  },
}))

export default useStyles
